<template>
  <!-- FORMULARIO DE DEDPENDIENTES ECONÓMICOS -->
  <div>
    <h5 class="main-title">Dependientes económicos</h5>
    <fieldset>
    <!-- NOMBRE Y APELLIDO PATERNO -->
      <div class="row row-responsive">
        <!-- INICIA NOMBRE -->
        <div class="column column-xs-100 column-sm-50">
          <label
            for="name"
            :class="{
                'error-text': $v.userDependant.name.$invalid
                && dependentFormSubmitted }">
                Nombre:
          </label>
          <input
            type="text"
            v-model.trim="$v.userDependant.name.$model"
            :class="{ 'error-label': $v.userDependant.name.$invalid
                    && dependentFormSubmitted }"
            placeholder="Nombre"
          />
          <!-- INICIAN VALIDACIONES DE NOMBRE -->
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.name.required"
            class="error"
          >
            Este campo es obligatorio.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.name.minLength"
            class="error"
          >
            El nombre debe de tener más de
            {{ $v.userDependant.name.$params.minLength.min }} letras.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.name.validateName"
            class="error"
          >
            El nombre es incorrecto.
          </div>
        </div>
        <!-- INICIA APELLIDO PATERNO -->
        <div class="column column-xs-100 column-sm-50">
          <label
            for="father_surname"
            :class="{
                'error-text': $v.userDependant.fatherSurname.$invalid
                && dependentFormSubmitted }">
                Apellido paterno:
          </label>
          <input
            type="text"
            v-model.trim="$v.userDependant.fatherSurname.$model"
            :class="{ 'error-label': $v.userDependant.fatherSurname.$invalid
                    && dependentFormSubmitted }"
            placeholder="Apellido paterno"
          />
          <!-- INICIAN VALIDACIONES DE APELLIDO PATERNO -->
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.fatherSurname.required"
            class="error"
          >
            Este campo es obligatorio.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.fatherSurname.minLength"
            class="error"
          >
            El apellido paterno debe de tener más de
            {{ $v.userDependant.fatherSurname.$params.minLength.min }} letras.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.fatherSurname.validateName"
            class="error"
          >
            El apellido paterno es incorrecto.
          </div>
        </div>
      </div>
      <!-- APELLIDO MATERNO Y RELACIÓN -->
      <div class="row row-responsive">
        <!-- INICIA APELLIDO MATERNO -->
        <div class="column column-xs-100 column-sm-50">
          <label
            for="mother_surname"
            :class="{
                'error-text': $v.userDependant.motherSurname.$invalid
                && dependentFormSubmitted }">
                Apellido materno:
          </label>
          <input
            type="text"
            v-model.trim="$v.userDependant.motherSurname.$model"
            :class="{ 'error-label': $v.userDependant.motherSurname.$invalid
                    && dependentFormSubmitted }"
            placeholder="Apellido materno"
          />
          <!-- INICIAN VALIDACIONES APELLIDO MATERNO -->
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.motherSurname.required"
            class="error"
          >
            Este campo es obligatorio.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.motherSurname.minLength"
            class="error"
          >
            El apellido materno debe de tener más de
            {{ $v.userDependant.motherSurname.$params.minLength.min }} letras.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.motherSurname.validateName"
            class="error"
          >
            El apellido materno es incorrecto.
          </div>
        </div>

        <!-- INICIA RELACION -->
        <div class="column column-xs-100 column-sm-50">
          <label
            for="relationship"
            :class="{
                'error-text': $v.userDependant.relationship.$invalid
                && dependentFormSubmitted }">
                Relación:
          </label>
          <span class="select">
            <select
              v-model.trim="$v.userDependant.relationship.$model"
              :class="{ 'error-label': $v.userDependant.relationship.$invalid
                    && dependentFormSubmitted }"
            >
              <option value="" disabled selected>Seleccione:</option>
              <option
                v-for="relation in RELATIONS.data"
                :value="relation.value"
                :key="relation.id">
                  {{ relation.name }}
              </option>
            </select>
            <span class="arrow"></span>
          </span>
          <!-- INICIAN VALIDACIONES DE RELACIÓN -->
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.relationship.required"
            class="error"
          >
            Este campo es obligatorio.
          </div>
        </div>
      </div>

      <!-- RFC O CURPP -->
      <div class="row row-responsive">

        <!-- INICIA RFC O CURP -->
        <div class="column column-xs-100 column-sm-50">
          <label
            for="rfc_curp"
            :class="{
                'error-text': $v.userDependant.rfcOrCurp.$invalid
                && dependentFormSubmitted }"
          >
                RFC ó CURP:
          </label>
          <input
            type="text"
            v-model.trim="$v.userDependant.rfcOrCurp.$model"
            id="rfc-curp"
            :class="{ 'error-label': $v.userDependant.rfcOrCurp.$invalid
                    && dependentFormSubmitted }"
            placeholder="RFC ó CURP"
          />

          <!-- INICIAN VALIDACIONES RFC O CURP -->
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.rfcOrCurp.required"
            class="error"
          >
            Este campo es obligatorio.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.rfcOrCurp.minLength"
            class="error"
          >
            Este campo debe tener mínimo
            {{ $v.userDependant.rfcOrCurp.$params.minLength.min }} caracteres.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.rfcOrCurp.maxLength"
            class="error"
          >
            Este campo debe tener máximo
            {{ $v.userDependant.rfcOrCurp.$params.maxLength.max }} caracteres.
          </div>
          <div
            v-if="dependentFormSubmitted
            && !$v.userDependant.rfcOrCurp.rfcOrCurpValidation"
            class="error"
          >
            El RFC o CURP es incorrecto.
          </div>
        </div>
      </div>
  </fieldset>
  <div class="btn-container">
    <div>
      <button v-if="getDependentsCount !== 0"
        @click.prevent="cancelDependent">
        Cancelar
      </button>
    </div>
    <div>
      <button
        class="button btn--m"
        @click.prevent="saveDependent">
        Guardar dependiente
      </button>
    </div>
  </div>
</div>
</template>

<script>
import { minLength, maxLength, required }
  from 'vuelidate/lib/validators'
import RELATIONS from '@/constants/relations'

const validateName = (field) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/i.test((field))

const rfcOrCurpValidation = (field) => {
  if (
    /^([a-zñA-ZÑ&]{3,4})(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))([a-zA-Z\d]{2})([A\d])$/.test(field) ||
    /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/i.test(field)
  ) {
    return true
  }
  return false
}

export default {
  name: 'DependentForm',
  validations: {
    userDependant: {
      name: {
        required,
        minLength: minLength(2),
        validateName
      },
      fatherSurname: {
        required,
        minLength: minLength(2),
        validateName
      },
      motherSurname: {
        required,
        minLength: minLength(2),
        validateName
      },
      relationship: { required },
      rfcOrCurp: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(18),
        rfcOrCurpValidation
      }
    }
  },
  data () {
    return {
      RELATIONS,
      dependentID: '',
      dependentFormSubmitted: false,
      userDependant: {
        name: '',
        fatherSurname: '',
        motherSurname: '',
        relationship: '',
        rfcOrCurp: ''
      }
    }
  },
  computed: {
    getDependentsCount: function () {
      return this.$store.getters['pep/getDependents'].length
    }
  },
  created: function () {
    this.dependentID = this.$store.getters['pep/getDependentID']
    if (this.dependentID !== '') {
      const dependent =
        this.$store.getters['pep/getDependentByID'](this.dependentID)
      this.userDependant.name = dependent.name
      this.userDependant.fatherSurname = dependent.middle_name
      this.userDependant.motherSurname = dependent.last_name
      this.userDependant.relationship = dependent.relationship
      this.userDependant.rfcOrCurp = dependent.rfc_curp
    }
  },
  methods: {
    saveDependent: function () {
      this.dependentFormSubmitted = true
      if (this.$v.userDependant.$invalid) return false

      if (this.dependentID === '') {
        this.$store.dispatch('pep/addDependent', this.userDependant)
      } else {
        this.updateDependent()
      }
      this.$emit('displayAllDependents', true)
    },
    cancelDependent: function () {
      this.$store.dispatch('pep/removeDependentID')
      this.$emit('displayAllDependents', true)
    },
    updateDependent: function () {
      let dependentToUpdate = {...this.userDependant, id: this.dependentID}
      this.$store.dispatch(
        'pep/updateDependent',
        dependentToUpdate
      )
    }
  }
}
</script>

<style lang="scss" scoped>

  input#rfc-curp{
    text-transform: uppercase;
  }

  .btn-container {
    display: flex;
    flex-direction: column;
    align-items: end;
  }

  @media (min-width: 768px) {
    .btn-container {
      flex-direction: row;
      justify-content: end;
    }

    .btn--m {
      margin-left: 2em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/EconomicDependents/DependentForm.vue